'use client';

import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmArrowRight } from '@websolutespa/bom-mixer-icons';
import { LlmBlock, LlmChunkAction, LlmChunkActionItem } from '../../../types';
import { useLlm } from '../../../useLlm/useLlm';
import { useLlmView } from '../../../useLlm/useLlmView';
import { Cta } from '../../components/Cta/cta';

export const Action: React.FC<LlmBlock<LlmChunkActionItem | LlmChunkAction>> = (props) => {
  const { item } = props;
  const label = useLabel();
  const { onAction } = useLlm(state => state.actions);
  const { open } = useLlmView(state => state.actions);
  const dismissable = useLlmView(state => state.dismissable);
  const onAction_ = async (event: React.MouseEvent) => {
    // console.log('Action.onAction', item.id);
    const shouldClose = await onAction(item);
    if (dismissable && shouldClose !== false) {
      open();
    }
  };
  const classNames = getClassNames('llm__action', { [`llm__action--${item.type}`]: !!item.type });
  return (
    <Cta
      type="button"
      className={classNames} label={item.title || label('llm.tellMeMore')}
      icon={<IconLlmArrowRight />}
      onClick={onAction_}
    />
  );
};

